import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CalculadoraRiesgos.css';

const CalculadoraRiesgos = () => {
  const navigate = useNavigate();
  const [preguntas, setPreguntas] = useState({
    pregunta1: null,
    pregunta2: null,
    pregunta3: null,
    pregunta4: null,
    pregunta5: null
  });
  const [resultado, setResultado] = useState(null);
  const [mostrarResultado, setMostrarResultado] = useState(false);

  const preguntasLista = [
    {
      id: 'pregunta1',
      texto: 'El vendedor te entrego los documentos completos del vehiculo?',
      opciones: [
        { valor: 0, texto: 'Si, todos los documentos originales' },
        { valor: 1, texto: 'Solo fotocopias' },
        { valor: 2, texto: 'No me entregaron documentos' }
      ]
    },
    {
      id: 'pregunta2',
      texto: 'Verificaste que la placa coincida con la tarjeta de propiedad?',
      opciones: [
        { valor: 0, texto: 'Si, todo coincide' },
        { valor: 1, texto: 'No lo verifique' },
        { valor: 2, texto: 'Hay diferencias en los numeros' }
      ]
    },
    {
      id: 'pregunta3',
      texto: 'El vehiculo tiene multas o comparendos pendientes?',
      opciones: [
        { valor: 0, texto: 'No, esta libre de multas' },
        { valor: 1, texto: 'No lo se, no consulte' },
        { valor: 2, texto: 'Si, tiene multas pendientes' }
      ]
    },
    {
      id: 'pregunta4',
      texto: 'El vehiculo tiene deudas de impuestos o SOAT?',
      opciones: [
        { valor: 0, texto: 'No, todo al dia' },
        { valor: 1, texto: 'No lo se, no consulte' },
        { valor: 2, texto: 'Si, tiene deudas pendientes' }
      ]
    },
    {
      id: 'pregunta5',
      texto: 'Verificaste en RUNT que no tenga embargos o prendas?',
      opciones: [
        { valor: 0, texto: 'Si, verifique y esta libre' },
        { valor: 1, texto: 'No lo verifique' },
        { valor: 2, texto: 'Tiene embargos o prendas' }
      ]
    }
  ];

  const handleRespuesta = (preguntaId, valor) => {
    setPreguntas(prev => ({
      ...prev,
      [preguntaId]: valor
    }));
  };

  const calcularRiesgo = () => {
    const todasRespondidas = Object.values(preguntas).every(v => v !== null);
    if (!todasRespondidas) {
      alert('Por favor responde todas las preguntas');
      return;
    }

    const total = Object.values(preguntas).reduce((sum, val) => sum + val, 0);
    
    let nivel = '';
    let color = '';
    let recomendacion = '';
    
    if (total <= 2) {
      nivel = 'Riesgo Bajo';
      color = '#2ecc71';
      recomendacion = 'El vehiculo parece estar en buenas condiciones legales. Sin embargo, te recomendamos contar con asesoria legal para asegurar la transaccion.';
    } else if (total <= 5) {
      nivel = 'Riesgo Medio';
      color = '#f39c12';
      recomendacion = 'Existen algunas inconsistencias. Es importante que realices verificaciones adicionales y cuentes con acompanamiento legal antes de concretar la compra.';
    } else {
      nivel = 'Riesgo Alto';
      color = '#e74c3c';
      recomendacion = 'El vehiculo presenta serios riesgos legales. Te recomendamos NO realizar la compra sin antes obtener asesoria legal especializada para evitar consecuencias negativas.';
    }

    setResultado({
      total,
      nivel,
      color,
      recomendacion,
      maxPuntaje: 10
    });
    setMostrarResultado(true);
  };

  const reiniciar = () => {
    setPreguntas({
      pregunta1: null,
      pregunta2: null,
      pregunta3: null,
      pregunta4: null,
      pregunta5: null
    });
    setResultado(null);
    setMostrarResultado(false);
  };

  const getIcono = (nivel) => {
    if (nivel === 'Riesgo Bajo') {
      return (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    } else if (nivel === 'Riesgo Medio') {
      return (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        </svg>
      );
    } else {
      return (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      );
    }
  };

  return (
    <div className="calculadora-container">
      <div className="calculadora-header">
        <button className="btn-volver-inicio" onClick={() => navigate('/')}>
          ← Volver al Inicio
        </button>
        <h1>Calculadora de Riesgos</h1>
        <p>Evalua el riesgo legal de comprar un vehiculo usado</p>
      </div>

      {!mostrarResultado ? (
        <>
          <div className="preguntas-container">
            {preguntasLista.map((pregunta, index) => (
              <div key={pregunta.id} className="pregunta-card">
                <h3>Pregunta {index + 1}</h3>
                <p className="pregunta-texto">{pregunta.texto}</p>
                <div className="opciones">
                  {pregunta.opciones.map((opcion, idx) => (
                    <label key={idx} className="opcion-label">
                      <input
                        type="radio"
                        name={pregunta.id}
                        value={opcion.valor}
                        checked={preguntas[pregunta.id] === opcion.valor}
                        onChange={() => handleRespuesta(pregunta.id, opcion.valor)}
                      />
                      <span>{opcion.texto}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="calculadora-actions">
            <button className="btn-calcular" onClick={calcularRiesgo}>
              Calcular Riesgo
            </button>
            <button className="btn-reiniciar" onClick={reiniciar}>
              Reiniciar
            </button>
          </div>
        </>
      ) : (
        <div className="resultado-container">
          <div className="resultado-card" style={{ borderTop: `4px solid ${resultado.color}` }}>
            <div className="resultado-icono" style={{ color: resultado.color }}>
              {getIcono(resultado.nivel)}
            </div>
            <h2>Resultado: {resultado.nivel}</h2>
            <div className="puntaje">
              <div className="puntaje-bar">
                <div 
                  className="puntaje-fill" 
                  style={{ 
                    width: `${(resultado.total / resultado.maxPuntaje) * 100}%`,
                    backgroundColor: resultado.color 
                  }}
                />
              </div>
              <p>Puntaje: {resultado.total} de {resultado.maxPuntaje}</p>
            </div>
            <div className="recomendacion">
              <h3>Recomendacion:</h3>
              <p>{resultado.recomendacion}</p>
            </div>
            <div className="resultado-actions">
              <button className="btn-asesoria" onClick={() => window.location.href = '/asesoria'}>
                Solicitar Asesoria Legal
              </button>
              <button className="btn-volver" onClick={reiniciar}>
                Volver a Evaluar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="info-legal">
        <p>
          Esta calculadora es una herramienta informativa. Para una evaluacion completa,
          te recomendamos contactar a nuestros abogados especialistas.
        </p>
      </div>
    </div>
  );
};

export default CalculadoraRiesgos;